import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API_BASE = `${BACKEND_URL}/api`;

// Create axios instance with retry logic
export const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000, // Increased timeout to 30 seconds
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Add retry interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    
    // Only retry GET requests and only once
    if (config && !config._retry && config.method === 'get') {
      config._retry = true;
      console.log('[API] Retrying request:', config.url);
      
      // Wait a bit before retrying
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      return api(config);
    }
    
    return Promise.reject(error);
  }
);

export function withAuth(token) {
  return axios.create({
    baseURL: `${API_BASE}/admin`,
    timeout: 20000,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
}

export function absoluteBackendUrl(pathOrUrl) {
  const v = String(pathOrUrl || "");
  if (!v) return "";
  if (v.startsWith("http://") || v.startsWith("https://")) return v;
  return `${BACKEND_URL}${v.startsWith("/") ? "" : "/"}${v}`;
}

// Track clicks for analytics
export async function trackClick(type, targetId = "", targetName = "") {
  try {
    await api.post("/stats/click", { type, targetId, targetName });
  } catch {
    // Ignore tracking errors
  }
}
